import React from 'react';
import ReactDOM from 'react-dom/client'; // Met à jour l'import pour React 18
import App from './App';
import { ApolloProvider } from '@apollo/client';
import client from './apolloClient';
import './styles.css';
import i18n from './locales/index';  // Import direct de i18n
import { I18nextProvider } from 'react-i18next';

// Crée un root avec createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </ApolloProvider>
);
